<div
    [class]="displayAsCard() ? 'pt-12 pr-20 pb-12 pl-20 bg-white rounded-4' : ''"
    [class.section-ai-response]="includeResponseProfileImage()"
    ycnAgentLinkIntercept>
    <div class="section-ai-response-content" [class.pl-20]="!displayAsCard()" [class.pr-20]="!displayAsCard()">
        <div #aiResponseElement class="ai-md" [innerHTML]="messageHtml()"></div>
        @for (action of displayActions(); track $index) {
            @if (chartActionTemplate() && (action.name === 'create_fundamental_chart' || action.name === 'create_scatter_plot' || action.name === 'create_technical_chart') && action.display_result?.state) {
                @if ($index === 0) {
                    <hr>
                }
                <ng-container [ngTemplateOutlet]="chartActionTemplate()" [ngTemplateOutletContext]="{ $implicit: action }"/>
            } @else if (action.display_result?.type === 'download') {
                @if ($index === 0) {
                    <hr>
                }
                <ycn-agent-download-link [url]="action.display_result.url" [title]="action.display_result.title" />
            } @else if (action.display_result) {
                @if ($index === 0) {
                    <hr>
                }
                <div class="section-ai-response-link mb-2">
                    <div class="d-flex">
                        <a class="text-underline text-blue"
                           [href]="action.display_result.url"
                           target="_blank">
                            <span [textContent]="action.display_result.title"></span>
                        </a>
                    </div>
                </div>
            }
        }
    </div>
</div>
<ycn-agent-message-actions [contentElement]="aiResponseElement" (deleteChat)="deleteChat.emit()" />
